import CSS from "../assets/CSS.png";
import Firebase from "../assets/firebase.png";
import Git from "../assets/git.png";
import JavaScript from "../assets/javascript.png";
import NextJs from "../assets/nextjs.png";
import ReactLogo from "../assets/react.png";
import Redux from "../assets/redux.jpg";
import SASS from "../assets/sass.png";
import Tailwind from "../assets/TailwindCSS.png";
import Bootstrap from "../assets/Bootstrap.png";
import Typescript from "../assets/typescript.png";

export const languagesData = [
  {
    id: 1,
    languageImage:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/HTML5_Badge.svg/240px-HTML5_Badge.svg.png",
    languageName: "HTML",
  },
  {
    id: 2,
    languageImage: CSS,
    languageName: "CSS",
  },
  {
    id: 3,
    languageImage: JavaScript,
    languageName: "Javascript",
  },
  {
    id: 4,
    languageImage: Typescript,
    languageName: "Typescript",
  },
  {
    id: 5,
    languageImage: ReactLogo,
    languageName: "React",
  },
  {
    id: 6,
    languageImage: NextJs,
    languageName: "NextJs",
  },
  {
    id: 7,
    languageImage: Redux,
    languageName: "Redux",
  },
  {
    id: 8,
    languageImage: Firebase,
    languageName: "Firebase",
  },
  {
    id: 9,
    languageImage: Git,
    languageName: "Git",
  },
  {
    id: 10,
    languageImage: SASS,
    languageName: "SASS",
  },
  {
    id: 11,
    languageImage: Tailwind,
    languageName: "TailwindCSS",
  },
  {
    id: 12,
    languageImage: Bootstrap,
    languageName: "Bootstrap",
  },
];
